enum IntegrationStatus {
  LINKED = "linked",
  UNLINKED = "unlinked",
  PENDING = "pending"
}

export default IntegrationStatus;